import { render, staticRenderFns } from "./RegistrosAnterioresBusca.vue?vue&type=template&id=b8f861e6&scoped=true&"
import script from "./RegistrosAnterioresBusca.vue?vue&type=script&lang=js&"
export * from "./RegistrosAnterioresBusca.vue?vue&type=script&lang=js&"
import style0 from "./RegistrosAnterioresBusca.vue?vue&type=style&index=0&id=b8f861e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f861e6",
  null
  
)

export default component.exports